import Layout from '@/features/common/Layout';
import { useRole } from '@/hooks/useRole';
import BannerForm from './BannerForm';

const Banner = () => {
  useRole('marketing');

  return (
    <Layout pageTitle="Banner Configuration">
      <BannerForm />
    </Layout>
  );
};

export default Banner;
